import Model from './base/model';

class ShipperOccurrence extends Model {
  resourceName() {
    return 'shipper_occurrences';
  }

  fields() {
    return {
      code: '',
      description: '',
    }
  }
}

export default new ShipperOccurrence();
